// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

#sticker-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  color: #696969;
  font-size: 2rem;
  text-align: center;
}
#sticker-dropzone small {
  font-size: 1.6rem;
}
#sticker-dropzone u {
  font-size: 1.8rem;
}
#sticker-dropzone .text-magenta {
  color: #ab3a72;
}
#sticker-dropzone .browse-btn {
  cursor: pointer;
}
#sticker-dropzone .text-dark-gray {
  color: #292727;
}
#sticker-dropzone #sticker-upload-icon {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 0.625rem;
}
#sticker-dropzone #sticker-upload-icon .stroke {
  stroke: #ab3a72;
}
#sticker-dropzone #sticker-upload-icon .fill {
  fill: #ab3a72;
}
#sticker-dropzone .disclaimer {
  position: absolute;
  bottom: 1.6rem;
  font-size: 1.2rem;
  align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Stickers/StickerDropZone.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cDLc;ECMd,eAAA;EACA,kBAAA;AAGF;AADE;EACE,iBAAA;AAGJ;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,cDEM;ACDV;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,cD3BQ;AC0BZ;AAIE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AAFJ;AAII;EACE,eDhBI;ACcV;AAKI;EACE,aDpBI;ACiBV;AAOE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AALJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n#sticker-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.6rem;\n  color: $darkTextColor;\n  font-size: 2rem;\n  text-align: center;\n\n  small {\n    font-size: 1.6rem;\n  }\n\n  u {\n    font-size: 1.8rem;\n  }\n\n  .text-magenta {\n    color: $magenta;\n  }\n\n  .browse-btn {\n    cursor: pointer;\n  }\n\n  .text-dark-gray {\n    color: $textColor;\n  }\n\n  #sticker-upload-icon {\n    display: block;\n    width: 40px;\n    height: 40px;\n    margin-bottom: 0.625rem;\n\n    .stroke {\n      stroke: $magenta;\n    }\n\n    .fill {\n      fill: $magenta;\n    }\n  }\n\n  .disclaimer {\n    position: absolute;\n    bottom: 1.6rem;\n    font-size: 1.2rem;\n    align-self: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
